import React from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';
import GeneralItem from '../GeneralItem';
import { CompleteExpressQueryKiosk_company_categories_items } from '~Scenes/SelfServiceKiosks/Components/useExpressQuery/__queries__';
import { LocalItem } from '~Types';

const Wrapper = styled.div``;

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;

  @media (orientation: landscape) {
    max-width: 1400px;
    margin: 0 auto;
  }
`;

interface Props {
  items: CompleteExpressQueryKiosk_company_categories_items[];
  onClickItem: (id: string, instant?: boolean) => void;
  cartItems: LocalItem[];
}

const LargeItems = ({ items, onClickItem, cartItems }: Props) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <Items>
        {items.map((item) => (
          <GeneralItem
            large
            key={item.id}
            id={item.id}
            description={item.descriptionLang}
            variations={item.modificationGroups}
            upsales={item.upsales}
            image={item?.image?.file.url}
            title={i18n(item.titleLang)}
            onClick={onClickItem}
            cartItems={cartItems}
          />
        ))}
      </Items>
    </Wrapper>
  );
};

export default LargeItems;
